import { z } from 'zod';

import { ComponentInstanceSchema } from './DiagramComponentInstance.schema';
import { EdgeSchema } from './Edge.schema';

export const AnchorSchema = z.object({
    componentInstanceId: ComponentInstanceSchema.shape.id,
    edge: EdgeSchema,
    offset: z.number().gte(0).default(0),
    port: z.number().gte(0).nullable().default(null),
});
